// extracted by mini-css-extract-plugin
export default {"products":"vu-z","card":"wu-z","oosMessaging":"xu-z"};